import React, { useEffect, useState } from "react";
import { useTable, useExpanded } from "react-table";
import "./ReactTable.scss";
import {
  Button,
  MenuItem,
  Pagination,
  PaginationItem,
  Select,
} from "@mui/material";

const ReactTable = ({ columns, data, renderRowSubComponent }) => {
  console.log("renderRowSubComponent", renderRowSubComponent);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); // Set default page size to 10
  const [gotoPageInput, setGotoPageInput] = useState("");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    toggleRowExpanded,
  } = useTable(
    {
      columns,
      data,
    },
    useExpanded
  );

  const totalItems = rows.length;
  const totalPages = Math.ceil(totalItems / pageSize);

  const getPageItems = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, totalItems);
    return rows.slice(startIndex, endIndex);
  };

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setGotoPageInput("");
    }
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    setPageSize(newPageSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const formatPageNumber = (page) => {
    return page < 10 ? `0${page}` : page;
  };

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 650);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="main_table">
      <div className="table_container">
        <table {...getTableProps()} className="table">
          <thead className="table_head">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} className="head_row">
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            {...getTableBodyProps()}
            className={`table_tbody ${totalItems === 0 ? "noDataBody" : ""}`}
          >
            {totalItems === 0 ? (
              <tr>
                <td colSpan={columns.length} className="no-data-message">
                  No data available
                </td>
              </tr>
            ) : (
              getPageItems().map((row, index) => {
                prepareRow(row);
                console.log("row", row);
                return (
                  <>
                    <tr
                      {...row.getRowProps()}
                      className="tbody_row"
                      key={index}
                    >
                      {row.cells.map((cell) => (
                        <td
                          {...cell.getCellProps()}
                          onClick={() =>
                            cell.column.Header === "Action" &&
                            toggleRowExpanded(row.id)
                          }
                        >
                          {cell.render("Cell")}
                        </td>
                      ))}
                    </tr>
                    {row.isExpanded && renderRowSubComponent ? (
                      <tr className="tbody_row">
                        <td colSpan={columns.length}>
                          {renderRowSubComponent({ row })}
                        </td>
                      </tr>
                    ) : null}
                  </>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 0 && (
        <div className="paginationComponent">
          <div className="pagination_container">
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              boundaryCount={2}
              siblingCount={1}
              variant="outlined"
              shape="rounded"
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  components={{
                    previous: () => (
                      <Button
                        variant="outlined"
                        onClick={() => handlePageChange(null, currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        {isSmallScreen ? `<` : `< Previous`}
                      </Button>
                    ),
                    next: () => (
                      <Button
                        variant="outlined"
                        onClick={() => handlePageChange(null, currentPage + 1)}
                        disabled={currentPage === totalPages}
                      >
                        {isSmallScreen ? `>` : `Next >`}
                      </Button>
                    ),
                  }}
                  // Format page label with leading zero
                  page={formatPageNumber(item.page)}
                />
              )}
            />
          </div>
          <div className="pageSizeSelectorComponent">
            <div className="goto-page-input">
              <input
                type="number"
                placeholder="Go to Page"
                value={gotoPageInput}
                onChange={(e) => setGotoPageInput(e.target.value)}
              />
              <button className="goToButton" onClick={handleGotoPage}>
                Go
              </button>
            </div>
            <Select
              className="pageSizeSelector"
              value={pageSize}
              onChange={handlePageSizeChange}
              displayEmpty
              inputProps={{ "aria-label": "Page Size Selector" }}
              sx={{
                ".MuiSelect-icon": {
                  color: "white", // Makes the SVG icon white
                },
              }}
            >
              <MenuItem value={10}>10 / page</MenuItem>
              <MenuItem value={20}>20 / page</MenuItem>
              <MenuItem value={30}>30 / page</MenuItem>
              <MenuItem value={50}>50 / page</MenuItem>
              <MenuItem value={100}>100 / page</MenuItem>
            </Select>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReactTable;
